import { Radio } from '@mui/material';
import classes from './RadioButton.module.scss';

export default function RadioButton(props) {
  const { label, description, checked, onChange, disabled } = props;
  return (
    <div className={classes.checkBoxWrapper}>
      <Radio
        onClick={onChange}
        checked={checked}
        disabled={disabled}
        sx={{ '& .MuiSvgIcon-root': { fontSize: 22 }, padding: 0 }}
      />
      <div className={classes.textsWrapper}>
        <p className={disabled ? classes.checkBoxLabelDisable : classes.checkBoxLabel}>{label}</p>
        {description && <p className={classes.checkBoxDescription}>{description}</p>}
      </div>
    </div>
  );
}
